<template>
  <button :disabled="loading" class="flex items-center" style="color: black; font-weight: 700;">
    <div v-if="loading" class="btn-spinner mr-2" />
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    loading: Boolean,
  },
}
</script>